import { jsxs as e, jsx as c } from "react/jsx-runtime";
import { c as o, h as s } from "../../_chunks/VideoPlayerIcons.css.CABSRJZT.js";
const a = ({ size: r = 62 }) => /* @__PURE__ */ e(
  "svg",
  {
    width: r,
    height: r,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c("circle", { cx: "32", cy: "32", r: "31", className: o }),
      /* @__PURE__ */ c(
        "path",
        {
          className: s,
          d: "M26.2684 24.4476C26.2684 23.2651 27.5484 22.5261 28.5724 23.1173L42.3452 31.0691C43.3692 31.6603 43.3692 33.1383 42.3452 33.7295L28.5724 41.6812C27.5484 42.2724 26.2684 41.5334 26.2684 40.351L26.2684 24.4476Z"
        }
      )
    ]
  }
);
export {
  a as VideoPlayerPlayIcon
};
